module.exports = __webpack_public_path__ + "img/olark.328dbdfb.png";